module.exports = __webpack_public_path__ + "static/media/logo-wordmark.d74d0984.svg";